import React, { useState } from 'react'
import Navbar from './Navbar'
import "../Styles/DeviceTable.css"
import "../Styles/UserCard.css"
import { getUserDetails } from "../Utility/AsyncStorageData";
import axios from "axios";
import Header from "./Header";
import { useNavigate } from 'react-router-dom';
import Modal from "./Modal";
import { showToast } from './Toast';

import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

function WebDevice() {

  var userDetails = getUserDetails();
  let navigate = useNavigate();

  const [userList, setUserList] = React.useState([]);
  const [test, setTest] = React.useState(1);
  const [editBlock, setEditBlock] = React.useState(0);
  const [editUserDetail, setEditUserDetail] = React.useState({})
  const [openRow, setOpenRow] = useState(null);

  const [machineAssined, setMachineAssigned] = useState([])
  const [openDeviceAssign, setOpenDeviceAssign] = useState(false)
  const [deciceToAssign, setDeviceToAssign] = useState([])
  const [selectedAssignDevice, setSelectedAssignDevice] = useState({})
  const [machineListToAssign, setMachineListToAssign] = useState([])
  const [selectedAssignMachine, setSelectedAssignMachine] = useState({})
  const [assignDetails, setAssignDetails] = useState({})
  const [openDeleteDevice, setOpenDeleteDevice] = useState(false)





  const toggleRow = (id) => {
    setOpenRow(openRow === id ? null : id);
    setMachineAssigned([]);
  };


  const toggleSwitch = async (index, value) => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/api/addUser";
      let body = {
        comp_num: userDetails.comp_num,
        user_id: value.user_id,
        is_active: value.is_active === "Y" ? "N" : "Y"

      }
      // console.log("***********toggleSwitch************* ", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {
        // console.log("response: ", response.data);

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            setUserList(prevUserList => {
              let temp = [...prevUserList]
              temp[index].is_active = temp[index].is_active === "Y" ? "N" : "Y"
              return temp
            })

            showToast(response.data.msg, 3000, "green");
          }

          else {


            showToast(response.data.msg, 3000, "red");
            // console.log(" addUser error: ", response.data.msg);
          }

          // setLoading (false);
        }
      }).catch(error => {
        // console.log("error: ", error);
        if (error.response.status === 403) {
          navigate("/");
        }
        showToast(error, 3000, "red");
        return
      })
    } catch (error) {
      // console.log("error ", error)
      throw error;
    }

  }

  const handleFetchUsers = async () => {
    try {

      let url = process.env.REACT_APP_BASE_URL + "/api/listOfUser";
      let body = {
        comp_num: userDetails.comp_num,
        user_id: userDetails.user_id
      }
      // console.log("--------------listOfUser------------- ", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {
        // console.log("response: ", response.data);

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            setUserList(response.data.list)
            // if (response.data.list.length === 0) {
            //   setShowData(true);
            // }
            // else {
            //   setShowData(false);
            // }
          }

          else {


            showToast(response.data.msg, 3000, "red");
            console.log("listOfUser error: ", response.data.msg);
          }

          // setLoading (false);
        }

        else if (response.status === 403) {
          navigate("/");
        }
      }).catch(error => {
        console.log("error: ", error);
        if (error.response.status === 403) {
          navigate("/");
        }

        showToast(error, 3000, "red");
        return
      })

    } catch (error) {
      console.log("error ", error)
      throw error;
    }

  }


  const navbarRender = (data) => {
    // console.log('Data received from child:', data);
    setTest(!test)
  };

  const editUser = (item) => {
    // console.log("item", item)
    setEditUserDetail(item)
    setEditBlock(true)
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setEditUserDetail(values => ({ ...values, [name]: value }))
  }

  const closeAddSensorForm = async () => {
    // console.log("edituserdetails", editUserDetail)
    try {
      let url = process.env.REACT_APP_BASE_URL + "/api/addUser";
      let body = {
        comp_num: userDetails.comp_num,
        added_by: userDetails.user_id,
        user_id: editUserDetail.user_id,
        name: editUserDetail.name,
        email: editUserDetail.contact,
        role_id: editUserDetail.role_id
      }
      // console.log("************addUser*********** ", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {
        // console.log("response: ", response.data);

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log(" addUser error: ", response.data.msg);
            showToast(response.data.msg, 3000, "green");
            handleFetchUsers()
            setEditBlock(false)
            setEditUserDetail({})
            return
          }

          else {
            setEditBlock(false)
            showToast(response.data.msg, 3000, "red");
            return
          }
        }
      }).catch(error => {
        console.log("error: ", error);
        setEditBlock(false)
        showToast(error, 3000, "red");
        return
      })
      setEditBlock(false)
    } catch (error) {
      console.log("error ", error)
      throw error;
    }
  }

  const roleID = (role) => {
    if (role === "A")
      return "Admin"
    else if (role === "C")
      return "Controller"
    else if (role === "F")
      return "Floor Manager"
    else if (role === "M")
      return "Machine Inchagre"
    else
      return "Owner"
  }

  const getAssignMachines = async (machineID) => {
    try {

      let url = process.env.REACT_APP_BASE_URL + "/api/machineAssignList";
      let body = {
        user_num: machineID
      }
      // console.log("--------------listOfUser------------- ", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {
        // console.log("response: ", response.data);
        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log(`machine assign to user`, response.data.data)
            setMachineAssigned(response.data.data)
          }
          else if (response.data.statusCode === 2) {
            setMachineAssigned([])
            showToast(response.data.msg, 3000, "red");
          }

          else {
            showToast(response.data.msg, 3000, "red");
            // console.log("listOfUser error: ", response.data.msg);
          }
        }

        else if (response.status === 403) {
          navigate("/");
        }
      }).catch(error => {
        console.log("error: ", error);


        showToast(error, 3000, "red");
        return
      })

    } catch (error) {
      console.log("error ", error)
      throw error;
    }
  }

  const getDeviceIdToAssign = async () => {
    try {

      let url = process.env.REACT_APP_BASE_URL + "/device/companyWiseDeviceList1";
      let body = {
        comp_num: userDetails.comp_num
      }
      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {
        // console.log("response: ", response.data);
        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log(`machine assign to user`, response.data.data)
            setDeviceToAssign(response.data.data)
          }

          else {
            showToast(response.data.msg, 3000, "red");
            // console.log("listOfUser error: ", response.data.msg);
          }
        }

        else if (response.status === 403) {
          navigate("/");
        }
      }).catch(error => {
        console.log("error: ", error);


        showToast(error, 3000, "red");
        return
      })

    } catch (error) {
      console.log("error ", error)
      throw error;
    }
  }

  const getAssignMachineList = async (device_id) => {
    try {

      let url = process.env.REACT_APP_BASE_URL + "/sensor/getSensorList";
      let body = {
        device_id: device_id
      }
      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {
        // console.log("response: ", response.data);
        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log(`machine assign to user`, response.data.result)
            setMachineListToAssign(response.data.result)
          }

          else {
            showToast(response.data.msg, 3000, "red");
            // console.log("listOfUser error: ", response.data.msg);
          }
        }

        else if (response.status === 403) {
          navigate("/");
        }
      }).catch(error => {
        console.log("error: ", error);


        showToast(error, 3000, "red");
        return
      })

    } catch (error) {
      console.log("error ", error)
      throw error;
    }
  }

  const submitAssign = async () => {
    // console.log("assignDetails", assignDetails, selectedAssignMachine, selectedAssignDevice)
    try {

      let url = process.env.REACT_APP_BASE_URL + "/api/machineAssign";
      let body = {
        user_num: assignDetails.user_id,
        device_id: selectedAssignDevice,
        machine_id: selectedAssignMachine
      }
      // console.log("body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {
        // console.log("response: ", response.data);
        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            showToast(response.data.msg, 3000, "green");
            getAssignMachines(assignDetails.user_id)
            setOpenDeviceAssign(false)
            setSelectedAssignDevice({})
            setSelectedAssignMachine({})
          }

          else {
            showToast(response.data.msg, 3000, "red");
            // console.log("listOfUser error: ", response.data.msg);
          }
        }

        else if (response.status === 403) {
          navigate("/");
        }
      }).catch(error => {
        // console.log("error: ", error);
        showToast(error, 3000, "red");
        return
      })

    } catch (error) {
      // console.log("error ", error)
      throw error;
    }
  }

  const deleteAssignMachine = async () => {

    try {
      let url = process.env.REACT_APP_BASE_URL + "/api/machineAssign";
      let body = {
        user_num: assignDetails.user_id,
        machine_id: assignDetails.mid,
        is_active: "N"
      }
      // console.log("body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userDetails.access_token}`
        },
      }).then(response => {
        // console.log("response: ", response.data);
        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            showToast(response.data.msg, 3000, "green");
            getAssignMachines(assignDetails.user_id)
            setOpenDeleteDevice(false)
            setAssignDetails({})
          }

          else {
            showToast(response.data.msg, 3000, "red");
            // console.log("listOfUser error: ", response.data.msg);
          }
        }

        else if (response.status === 403) {
          navigate("/");
        }
      }).catch(error => {
        // console.log("error: ", error);
        showToast(error, 3000, "red");
        return
      })

    } catch (error) {
      console.log("error ", error)
      throw error;
    }
  }

  React.useEffect(() => {
    handleFetchUsers();
  }, []);


  return (
    <div className='main'>

      <div>
        <Navbar />
      </div>

      <div className='Admin_menu'>

        <Header show={1} sendNavbarToParent={navbarRender} />

        <h3 style={{ width: "100%", textAlign: "center", color: "rgb(5, 19, 120)" }}>All Users</h3>

        {/* <div className='user'> */}
        <div className='device_table'>
          <table>
            <thead>
              <tr>
                <th style={{ borderRadius: "10px 0 0 10px" }}>Name</th>
                <th> Role</th>
                <th>Email & Contact No.</th>
                <th>Status</th>
                <th style={{ borderRadius: " 0 10px 10px 0" }}  >Action</th>
              </tr>
            </thead>
            <tbody>
              {userList.map((item, index) => (

                <>
                  <tr className="device_tr" key={index}>
                    <td style={{
                      borderRadius: "10px 0 0 10px",
                      borderBottom: openRow === item.device_id ? "none" : "1px solid #ccc "
                    }}>{item.name}</td>
                    <td style={{ borderBottom: openRow === item.device_id ? "none" : "1px solid #ccc " }}>{roleID(item.role_id)}</td>
                    <td style={{ borderBottom: openRow === item.device_id ? "none" : "1px solid #ccc " }}>{item.email !== "NA" ? item.email : item.contact}</td>
                    <td style={{ borderBottom: openRow === item.device_id ? "none" : "1px solid #ccc " }}><div onClick={() => { toggleSwitch(index, item) }} style={{
                      width: 15, height: 15, borderRadius: "50%", backgroundColor: (item.is_active === "Y" ? "green" : 'red'), textAlign: "center"
                    }}
                      data-tooltip-id="my-tooltip2" data-tooltip-content={item.is_active === "Y" ? "Deactivate User" : "Activate User"}
                    ></div> </td>
                    <td style={{ borderRadius: " 0 10px 10px 0", borderBottom: openRow === item.device_id ? "none" : "1px solid #ccc ", justifyContent:((item.role_id === "F" || item.role_id === "M") ? "space-between" : "flex-start"), display: "flex"}}>
                      <i className="fa-solid fa-pen" onClick={() => editUser(item)} data-tooltip-id="my-tooltip" data-tooltip-content="Click to Edit"></i>
                      {(item.role_id === "F" || item.role_id === "M") && (
                        <i
                          className={`fa-solid ${openRow === item.device_id ? "fa-chevron-up" : "fa-chevron-down"}`}
                          onClick={() => {
                            toggleRow(item.device_id);
                            if (openRow !== item.device_id) {
                              getAssignMachines(item.user_id)
                            }
                          }}
                          style={{ cursor: "pointer" }}
                          data-tooltip-id="my-tooltip1" data-tooltip-content="Show Assigned Machine"
                        ></i>)}

                    </td>
                    <Tooltip id="my-tooltip" />
                    <Tooltip id="my-tooltip1" />
                    <Tooltip id="my-tooltip2" />
                  </tr >

                  {(item.role_id === "F" || item.role_id === "M") &&
                    openRow === item.device_id && (
                      <tr className="expand-tr">
                        <td colSpan="5" className="expand-td">
                          <div className="expand-box">
                            <div className='expand-box-col1'>
                              <h4>Assined Machines</h4>

                              {machineAssined.map((machine, index) => {
                                return (
                                  <h5 key={index}> {`${machine.sensor_name}`} <i className="fa fa-trash" onClick={() => { setAssignDetails({ mid: machine.sensor_data._id, user_id: item.user_id, m_name: machine.sensor_name }); setOpenDeleteDevice(true); toggleRow(item.device_id); }}
                                    data-tooltip-id="my-tooltip1" data-tooltip-content="Delete Machine"></i></h5>
                                )
                              }
                              )}
                            </div>
                            <div className='expand-box-col2' onClick={() => { getDeviceIdToAssign(); setOpenDeviceAssign(true); setAssignDetails(item) }}>
                              Assign New Machine
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}


                </>
              ))}
            </tbody>
          </table>
        </div>

        <Modal isOpen={openDeleteDevice} style={{ width: "60%" }}>
          <h2 style={{ margin: "0", padding: "0", fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif" }}>Do You Want to Delete {assignDetails.m_name} </h2>
          <hr></hr>
          <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%", marginTop: 20 }}>
            <button style={{ padding: "8px 16px", background: "#252B42", color: "white", borderRadius: 10, border: "none", fontSize: 16, letterSpacing: 1 }}
              onClick={() => { setOpenDeleteDevice(false); setAssignDetails({}) }}>Cancle</button>
            <button style={{ padding: "8px 16px", background: "white", color: "#252B42", borderRadius: 10, fontSize: 16, letterSpacing: 1, border: "1px solid gray" }}
              onClick={deleteAssignMachine}>Delete Machine</button>
          </div>
        </Modal>


        <Modal isOpen={openDeviceAssign} style={{ width: "60%" }}>
          <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <h2 style={{ margin: "0", padding: "0", fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif" }}>Assign Machine</h2>
            <i className="fa fa-close" onClick={() => { setOpenDeviceAssign(false); setSelectedAssignDevice({}); setSelectedAssignMachine({}) }}></i>
          </div>
          <div>
            <label>Assign Device</label>
            <select
              className="custom-dropdown"
              name="device"
              value={selectedAssignDevice}
              onChange={(e) => { setSelectedAssignDevice(e.target.value); getAssignMachineList(e.target.value) }}
            >
              <option value="" autofocus hidden required>
                Select Device
              </option>
              {deciceToAssign.map((item) => (
                <option key={item.device_id} value={item.device_id}>
                  {item.device_name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Assign Machine</label>
            <select
              className="custom-dropdown"
              name="device"
              value={selectedAssignMachine}
              onChange={(e) => { setSelectedAssignMachine(e.target.value) }}
            >
              <option value="" autofocus hidden required>
                Select Machine
              </option>
              {machineListToAssign.map((item) => (
                <option key={item.sensor_id} value={item._id}>
                  {item.sensor_name}
                </option>
              ))}
            </select>

          </div>


          <button
            onClick={submitAssign}
            style={{
              backgroundColor: "#252B42 ", borderRadius: "10px", textDecoration: "none",
              border: "0", marginTop: "20px", color: "white", fontSize: "17px", fontWeight: "500", padding: 10
            }}>Submit
          </button>
        </Modal>


        <Modal isOpen={editBlock} style={{ width: "60%" }}>
          <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <h2 style={{ margin: "0", padding: "0", fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif" }}>{editUserDetail?.user_id ? "Edit User" : "Add User"}</h2>
            <i className="fa fa-close" onClick={() => { setEditBlock(false); setEditUserDetail([]) }}></i>
          </div>
          <div>
            <label>Enter User Name</label>
            <input className='inputField'
              type="text"
              name="name"
              value={editUserDetail.name || ""}
              onChange={handleChange}
            />
          </div>
          {editUserDetail.user_id === undefined ?
            <div> 
              <div>
                <label>Enter Contact no </label>
                <input className='inputField'
                  type="number"
                  name="contact"
                  value={editUserDetail.contact || ""}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label>Select User Role</label>
                <select
                  className="custom-dropdown"
                  name="role_id"
                  value={editUserDetail.role_id}
                  onChange={handleChange}
                >
                  <option value="" hidden>Select...</option> {/* Placeholder option */}
                  <option value="A">Admin</option>
                  <option value="O">Owner</option>
                  <option value="F">Floor Manager</option>
                  <option value="M">Machine Incharge</option>
                </select>
              </div>
            </div>
            :
            <></>
          }

          <button onClick={closeAddSensorForm}
            style={{
              backgroundColor: "#252B42 ", borderRadius: "10px", textDecoration: "none",
              border: "0", marginTop: "20px", color: "white", fontSize: "17px", fontWeight: "500", padding: 10
            }}>Submit
          </button>
        </Modal>

        {/* </div> */}
        <div className='addBlock1'>
          <i class="fa fa-plus-square" onClick={() => { setEditBlock(true) }}data-tooltip-id="my-tooltip1" data-tooltip-content="Click To Add User" ></i>
        </div>

      </div>
    </div >
  )
}

export default WebDevice
